import {
  BEN_IMAGE,
  IGOR_IMAGE,
  SUMMER_IMAGE,
  SIVA_IMAGE,
  STEVE_IMAGE,
  ARUN_IMAGE,
  MICHAEL_IMAGE,
  NAGARAJ_IMAGE,
  RAGAVI_IMAGE,
  SUJITH_IMAGE,
  VIJAY_IMAGE,
  INSIGHTS_BLOG_IMAGE1,
  INSIGHTS_BLOG_IMAGE2,
  INSIGHTS_BLOG_IMAGE3,
  INSIGHTS_EVENTS_IMAGE1,
  INSIGHTS_EVENTS_IMAGE2,
  INSIGHTS_EVENTS_IMAGE3,
  INSIGHTS_NEWS_IMAGE1,
  INSIGHTS_NEWS_IMAGE2,
  INSIGHTS_NEWS_IMAGE3,
  NEWS1_IMAGE1,
  NEWS1_IMAGE2,
  NEWS1_IMAGE3,
  NEWS1_IMAGE4,
  NEWS1_IMAGE5,
  NEWS1_IMAGE6,
  NEWS1_IMAGE7,
  NEWS1_IMAGE8,
  NEWS2_IMAGE1,
  NEWS2_IMAGE2,
  NEWS2_IMAGE3,
  NEWS2_IMAGE4,
  NEWS2_IMAGE5,
  NEWS2_IMAGE6,
  NEWS2_IMAGE7,
  EVENTS1_IMAGE1,
  EVENTS1_IMAGE2,
  EVENTS1_IMAGE3,
  EVENTS2_IMAGE1,
  EVENTS3_IMAGE1,
  EVENTS3_IMAGE2,
  HAND_WITH_BULB_IMAGE,
  BULB_GLOW_EFFECT,
  CLOUDS_3D_ILLUSTRATION,
  INSIGHTS_ROCKET,
  BLOG1_IMAGE1,
  BLOG2_IMAGE1,
  BLOG3_IMAGE1,
} from "../constants/imageConstants";

const imageMap: Record<string, string> = {
  // About Us Images
  BEN_IMAGE,
  IGOR_IMAGE,
  SUMMER_IMAGE,
  SIVA_IMAGE,
  STEVE_IMAGE,
  ARUN_IMAGE,
  MICHAEL_IMAGE,
  NAGARAJ_IMAGE,
  RAGAVI_IMAGE,
  SUJITH_IMAGE,
  VIJAY_IMAGE,
  
  // Insights Images
  INSIGHTS_BLOG_IMAGE1,
  INSIGHTS_BLOG_IMAGE2,
  INSIGHTS_BLOG_IMAGE3,
  INSIGHTS_EVENTS_IMAGE1,
  INSIGHTS_EVENTS_IMAGE2,
  INSIGHTS_EVENTS_IMAGE3,
  INSIGHTS_NEWS_IMAGE1,
  INSIGHTS_NEWS_IMAGE2,
  INSIGHTS_NEWS_IMAGE3,
  NEWS1_IMAGE1,
  NEWS1_IMAGE2,
  NEWS1_IMAGE3,
  NEWS1_IMAGE4,
  NEWS1_IMAGE5,
  NEWS1_IMAGE6,
  NEWS1_IMAGE7,
  NEWS1_IMAGE8,
  NEWS2_IMAGE1,
  NEWS2_IMAGE2,
  NEWS2_IMAGE3,
  NEWS2_IMAGE4,
  NEWS2_IMAGE5,
  NEWS2_IMAGE6,
  NEWS2_IMAGE7,
  BLOG1_IMAGE1,
  BLOG2_IMAGE1,
  BLOG3_IMAGE1,
  // Events Images
  EVENTS1_IMAGE1,
  EVENTS1_IMAGE2,
  EVENTS1_IMAGE3,
  EVENTS2_IMAGE1,
  EVENTS3_IMAGE1,
  EVENTS3_IMAGE2,
  // Services Images
  HAND_WITH_BULB_IMAGE,
  BULB_GLOW_EFFECT,
  
  // Insights Hero Images
  CLOUDS_3D_ILLUSTRATION,
  INSIGHTS_ROCKET,
};

export function mapImageConstant(imageConstant: string): string {
  return imageMap[imageConstant] || imageConstant;
}

export function mapImageConstants<T extends Record<string, any>>(data: T): T {
  const mapped = { ...data };
  
  // Recursively map image constants in nested objects
  function mapObject(obj: any): any {
    if (typeof obj === 'string' && imageMap[obj]) {
      return imageMap[obj];
    }
    
    if (Array.isArray(obj)) {
      return obj.map(mapObject);
    }
    
    if (obj && typeof obj === 'object') {
      const mappedObj: any = {};
      for (const key in obj) {
        if (key === 'image' || key === 'images') {
          mappedObj[key] = mapObject(obj[key]);
        } else {
          mappedObj[key] = mapObject(obj[key]);
        }
      }
      return mappedObj;
    }
    
    return obj;
  }
  
  return mapObject(mapped);
}
